import {
	getInquiriesByDateRange,
	getInquiries,
	patchInquiry,
	Inquiry,
	addInquiryMessage,
	getInquiryById,
	INQUIRY_REQUEST_STATUS
} from "../api/inquiries";
import { store } from "../store";
import { setSnackbarMessage } from "../actions/store/snackbar-actions";
import {
	updateInquiries as updateInquiriesInStore,
	updateSingleInquiry as updateSingleInquiryInStore,
	removeInquiry as removeInquiryInStore,
	removeArchivedInquiry as removeArchivedInquiryInStore,
	updateArchivedInquiries
} from "./store/app-actions";
import { addReservation } from "./reservation-actions";
import { addDays } from "date-fns";

export const getInquiriesAndUpdateStore = async (start: Date, end: Date) => {
	try {
		let inquiries;

		if (start && end) {
			inquiries = await getInquiriesByDateRange(start, end, INQUIRY_REQUEST_STATUS.ALL);
		} else {
			inquiries = await getInquiries();
		}

		store.dispatch(updateInquiriesInStore(inquiries));
	} catch (e) {
		if (e.message !== "Not Found") {
			store.dispatch(
				setSnackbarMessage(
					"Keine Resevierungen für den ausgewählten Zeitraum vorhanden!",
					"warning"
				)
			);
		}
	}

	try {
		let archiveInquiries;
		if (start && end) {
			archiveInquiries = await getInquiriesByDateRange(start, end, INQUIRY_REQUEST_STATUS.ARCHIVED);
		} else {
			const startDate = new Date();
			let endDate = addDays(startDate, 1825);

			startDate.setHours(0, 0, 0, 0);
			endDate.setHours(23, 59, 59, 999);

			archiveInquiries = await getInquiriesByDateRange(
				startDate, 
				endDate, 
				INQUIRY_REQUEST_STATUS.ARCHIVED
			);
		}

		store.dispatch(updateArchivedInquiries(archiveInquiries));
	} catch (e) {}
};

export const updateInquiry = async (
	id: string,
	updateData: Partial<Inquiry>
) => {
	try {
		const res = await patchInquiry(id, updateData);

		// If accepted, moved or rejected -> remove from store
		if (res.accepted || res.moved || res.rejected) {
			store.dispatch(removeInquiryInStore(id));
		} else {
			store.dispatch(updateSingleInquiryInStore(id, res));
		}
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Aktualisierung der Anfrage fehlgeschlagen!",
				"error"
			)
		);
	}
};

export const refreshInquiry = async (id: string) => {
	try {
		const res = await getInquiryById(id);

		store.dispatch(updateSingleInquiryInStore(id, res));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Aktualisierung der Anfrage fehlgeschlagen!",
				"error"
			)
		);
	}
};

export const addInquiryMessageAndUpdateStore = async (
	inquiryId: string,
	message: string
) => {
	try {
		await addInquiryMessage(inquiryId, message);
		const res = await getInquiryById(inquiryId);

		store.dispatch(updateSingleInquiryInStore(inquiryId, res));

		store.dispatch(
			setSnackbarMessage("Nachricht wurde gesendet!", "success")
		);
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage("Konnte Nachricht nicht senden!", "error")
		);
	}
};

export const restoreArchivedInquiry = async (
	id: string
) => {
	try {
		const res = await patchInquiry(id, {
			rejected: false
		});

		store.dispatch(removeArchivedInquiryInStore(id));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Aktualisierung der Anfrage fehlgeschlagen!",
				"error"
			)
		);
	}
};
